import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var EmailJSResponseStatus = function EmailJSResponseStatus() {
  var _status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Network Error';

  _classCallCheck(this, EmailJSResponseStatus);

  this.status = _status;
  this.text = _text;
};